// 不加密
const storageMap = (storage: Storage) => ({
  get(key: string) {
    try {
      return JSON.parse(storage.getItem(key));
    } catch (err) {
      return storage.getItem(key);
    }
  },
  set(key: string, value: any) {
    storage.setItem(key, JSON.stringify(value));
  },
  remove(key: string) {
    storage.removeItem(key);
  },
  clear() {
    storage.clear();
  },
});

export const ls = storageMap(localStorage);
export const ss = storageMap(sessionStorage);

export default { ls, ss }
